import { ActionTypes } from './actions-types'
import { MutationTypesContractor } from './mutations-types'
import { ClientApi } from '@/api/client'
import { Commit } from 'vuex'
import Router from '@/router'

export const actions = {
    async [ActionTypes.GET_CONTRACTORS]({ commit }: { commit: Commit }) {
        const request = new ClientApi();
        const response:any = await request.getContractors();

        commit(MutationTypesContractor.SET_CONTRACTORS, response.data)
    },
    async [ActionTypes.GET_CONTRACTOR]({ commit }: { commit: Commit }, uuid:string) {
        const request = new ClientApi();
        const response:any = await request.getContractor(uuid);

        commit(MutationTypesContractor.SET_CONTRACTOR, response.data)
    },
    async [ActionTypes.GET_REVIEW_CONTRACTOR]({ commit }: { commit: Commit }, uuid:string) {
        const request = new ClientApi();
        try {
            const response:any = await request.getReviewContractor(uuid);
            commit(MutationTypesContractor.SET_REVIEW_CONTRACTOR, response.data)
        } catch(err:any) {
            if (err.status === 404){
                return Router.replace({ name: 'page404' })
            }
        }

    },
}